import { render, staticRenderFns } from "./ElectricalMarine.vue?vue&type=template&id=494d3983&scoped=true&"
import script from "./ElectricalMarine.vue?vue&type=script&lang=js&"
export * from "./ElectricalMarine.vue?vue&type=script&lang=js&"
import style0 from "./ElectricalMarine.vue?vue&type=style&index=0&id=494d3983&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d3983",
  null
  
)

export default component.exports